import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import {
  fetchDownloadPackagesInWrongNodeRaport,
  fetchDownloadUnscannedPackagesRaport,
  getPackagesInWrongNode,
  getScannedPackagesFromBin,
  getUnscannedPackagesInVolume,
} from "../../../../redux/api/expedition.api";
import TableWidget from "../../../../components/tables/TableWidget";
import {
  getScannedPackagesFromBinTableHeaderTableData,
  scannedPackagesFromBinTableHeader,
} from "./components/tableConfigs/scannedPackagesFromBinTableConfig";
import { TableActions } from "../../../../components/tables/tableContext/TableContext";
import { clearPackagesFromBin } from "../../../../redux/reducer/expedition.reducer";
import NonConformingPackagesActionButtons from "./components/ActionButtons/NonConformingPackagesActionButtons";
import FormHeader from "../../../../components/misc/FormHeader";

function ScannedPackagesFromBin() {
  const dispatch = useAppDispatch();

  const { routeMainParam, routeParams } = useRoutesHelper();

  const { sn_bin, withProblems } = routeParams;

  const { nrVolum } = routeMainParam as { nrVolum: string };
  const { idBin } = routeMainParam as { idBin: string | number };

  const idBinNumber = Number(idBin);

  const {
    expedition: {
      scannedPackagesFromBin: {
        data: {
          data: scannedPackagesFromBinData,
          total: totalScannedPackagesFromBin,
        },
        isLoading: isLoadingScannedPackagesFromBin,
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  const handleScannedPackagesTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      nrVolum
    ) {
      if (withProblems === "notScanned") {
        dispatch(
          getUnscannedPackagesInVolume({
            page: action.tablePagination.page,
            per_page: action.tablePagination.rowsPerPage,
            nrVolum: nrVolum,
          }),
        );
      } else if (withProblems === "wrongNode") {
        dispatch(
          getPackagesInWrongNode({
            page: action.tablePagination.page,
            per_page: action.tablePagination.rowsPerPage,
            nrVolum: nrVolum,
          }),
        );
      } else {
        dispatch(
          getScannedPackagesFromBin({
            page: action.tablePagination.page,
            per_page: action.tablePagination.rowsPerPage,
            idBin: idBinNumber,
            nrVolum: nrVolum,
          }),
        );
      }
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearPackagesFromBin());
    };
  }, [dispatch]);

  const tableTitle = withProblems
    ? `Colete neconforme din volumul ${nrVolum}`
    : `Colete scanate din binul ${sn_bin}`;

  const handleDownloadPackagesInWrongNodeRaport = () => {
    if (!nrVolum) return;
    if (withProblems === "wrongNode") {
      dispatch(
        fetchDownloadPackagesInWrongNodeRaport({
          nrVolum: nrVolum,
        }),
      );
    }
  };

  const handleDownloadUnscannedPackagesRaport = () => {
    if (!nrVolum) return;
    if (withProblems === "notScanned") {
      dispatch(
        fetchDownloadUnscannedPackagesRaport({
          nrVolum: nrVolum,
        }),
      );
    }
  };

  const customTooltipTitle =
    withProblems === "wrongNode"
      ? "Descarca raport colete ajunse in nodul gresit"
      : "Descarca raport colete nescanate";

  const customDownloadButton =
    withProblems === "wrongNode"
      ? handleDownloadPackagesInWrongNodeRaport
      : handleDownloadUnscannedPackagesRaport;

  return (
    <TableWidget
      CustomHeaderComponent={() =>
        withProblems ? (
          <FormHeader
            title={tableTitle}
            buttonOnClick={customDownloadButton}
            buttonIcon="DOWNLOAD"
            tooltipTitle={customTooltipTitle}
          />
        ) : (
          <></>
        )
      }
      tableHeaderData={scannedPackagesFromBinTableHeader}
      tableItemsData={getScannedPackagesFromBinTableHeaderTableData(
        scannedPackagesFromBinData,
      )}
      totalItems={totalScannedPackagesFromBin}
      tableLoading={isLoadingScannedPackagesFromBin}
      handleTableActions={handleScannedPackagesTableActions}
      ActionButtonsComponent={NonConformingPackagesActionButtons}
      borderedRow
    />
  );
}

export default ScannedPackagesFromBin;
